<template>
<div>
<el-row>
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="title">
<h1>蜜罐</h1>
</div>
<div class="video">
<div class="">
<video controls="" muted="" src="../assets/project8.mp4">
                        我的天啊！我的视频在哪里？
                        </video>
</div>
</div>
<div class="paper_published">
                    第四届中国研究生移动端应用设计创新大赛全国一等奖（项目负责人）
                </div>
<div class="abstract">
                    蜜罐是电子支付时代新颖的虚拟储蓄助手，为帮助孩子树立理财意识、满足家长的金钱教育需求提供了解决方案。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/主效果图.jpg.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    设计创新点                </div>
<div class="text">
                    （一）儿童消费观念构建：
                    <br/><br/>一个。虚拟货币，非虚拟体验：给每一枚币的存储赋予仪式感，通过AR动画赋予虚拟货币真实感。
                    <br/><br/>  b.人工智能深度学习：孩子在日常生活中可以通过语音与蜜罐互动。 蜜罐将通过AI深度学习算法分析学习孩子的消费偏好，并给出消费建议，鼓励孩子自主合理消费。
                   <br/><br/> (2)金钱教育助理：
                    <br/><br/>一个。金钱教育情境：通过声光反馈，延长发放零用钱的时间，提供金钱教育情境。
                    <br/><br/>b.家长可以通过应用程序了解孩子的财务报告和消费习惯。它还可以提供教育建议；
                    <br/><br/>(3)激发孩子的兴趣：蜜罐可以贴在各种玩偶上，创造各种有趣的体验。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="12">
<div class="sub-title">
                   痛点
                </div>
<div class="text">
                    中国现在正处于移动支付时代。 2010年以后出生的孩子，从一睁眼起，就被移动支付包围着。不可否认，移动支付给我们的生活带来了极大的便利。然而，这种简单的支付方式无疑不利于孩子金钱观念的培养，他们甚至不知道钱是什么。
                   <br/><br/> 另一方面，对于父母来说，由于缺乏现金支付，他们无法再通过传统方式帮助孩子培养金钱观念。更糟糕的是，电话支付时间有限，导致孩子很难获得金钱教育的机会。
                </div>
</el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/poster1.jpg.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="8">
<div class="picture">
<img src="../assets/poster3.jpg.webp"/>
</div>
</el-col>
<el-col :span="12">
<div class="sub-title">
                    潜力和可扩展性                </div>
<div class="text">
                    我们希望通过蜜罐填补电子支付时代儿童金钱教育的空白，帮助孩子们树立正确的金钱观和更深刻的价值观。
                    <br/><br/>   从产品层面，我们希望未来能够开发出更加智能的语音交互功能，充分利用深度学习技术的特点为产品赋能，实现更加智能、便捷的产品升级。
                    <br/><br/>   从商业模式来看，儿童理财产品市场中，大部分只是手机应用程序，家长对孩子接触手机的情况始终敏感。因此，带有智能终端产品的移动应用程序会更容易被接受。而这个市场是空白的。未来我们的产品可以与支付宝、微信钱包等移动支付产品联动，打造儿童的“支付宝”或“微信钱包”。同时，我们的产品网上商店可以邀请商家入驻或接入电子商务平台。
                </div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
<el-row :gutter="40" style="margin-top: 50px">
<el-col :span="2"><div class="grid-content"></div></el-col>
<el-col :span="20">
<div class="picture">
<img src="../assets/poster4.jpg.webp"/>
</div>
</el-col>
<el-col :span="2"><div class="grid-content"></div></el-col>
</el-row>
</div>
</template>

<script>
    export default {
        name: "Project7Zh"
    }
</script>

<style scoped>
    .picture img{
        width: 100%;
    }
    .sub-title{
        margin-bottom: 20px;
        font-size: 15px;
        color: #666;
        font-weight: 400;
        text-align: justify;
    }
    .text{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .abstract{
        margin-top: 40px;
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;
    }
    .paper_published{
        margin-top: 24px;
        font-size: 15px;
        color: #333;
        font-weight: 400;
        text-align: justify;
        line-height: 1.9;
        border-bottom: 1px solid #333;
        padding-bottom: 6px;
    }
    video{
        width: 100%;
    }
    .grid-content{
        min-height: 36px;
    }
    .video{
        margin-top: 100px;
    }
    .title{
        margin-top: 100px;
        text-align: center;

    }
    .title a{
        color: #333;
    }
    .title p{
        color: #aaa;
        line-height: 30px;
    }
    .title h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        color: #333333;
    }
</style>